import { colors } from "theme";

import { TranslationKeys } from "types/locale";

export enum Operation {
  REPAIR = "REPAIR",
  REPLACE = "REPLACE",
  BLEND = "BLEND",
  REPLACE_AUXILIARY = "REPLACE_AUXILIARY",
  REPAIR_PAINT = "REPAIR_PAINT",
  PAINT = "PAINT",
}

export const OperationLabels: Record<Operation, TranslationKeys> = {
  REPAIR: "estimate.repair",
  REPLACE: "estimate.replace",
  BLEND: "estimate.blend",
  REPLACE_AUXILIARY: "estimate.replace_aux",
  REPAIR_PAINT: "estimate.repair_paint",
  PAINT: "estimate.paint",
} as const;

export type OperationColor = Operation | "DEFAULT" | "NONE";

export type ColorSet = {
  accent: string;
  textColor: string;
  partColor: string;
};

export const OperationColors: Record<OperationColor, ColorSet> = {
  PAINT: {
    accent: colors.yellow[5],
    partColor: colors.yellow[20],
    textColor: colors.yellow[60],
  },
  REPAIR: {
    accent: colors.orange[5],
    partColor: colors.orange[30],
    textColor: colors.orange[60],
  },
  REPLACE: {
    accent: colors.red[5],
    partColor: colors.red[40],
    textColor: colors.red[60],
  },
  BLEND: {
    accent: colors.yellow[5],
    partColor: colors.yellow[20],
    textColor: colors.yellow[60],
  },
  REPLACE_AUXILIARY: {
    accent: colors.red[5],
    partColor: colors.red[40],
    textColor: colors.red[60],
  },
  REPAIR_PAINT: {
    accent: colors.orange[5],
    partColor: colors.orange[30],
    textColor: colors.orange[60],
  },
  DEFAULT: {
    accent: colors.yellow[5],
    partColor: colors.yellow[20],
    textColor: colors.yellow[60],
  },
  NONE: {
    accent: colors.white,
    partColor: colors.white,
    textColor: colors.white,
  },
};
